import type { DaiseMessage } from '../daise/host'

/** DAISE's on-screen presence: system-feed lines, typed out, then archived. */
export class Feed {
  private root: HTMLElement
  private seq = 0

  constructor(private lingerMs: number) {
    this.root = document.getElementById('feed')!
  }

  present(msg: DaiseMessage): void {
    const line = document.createElement('div')
    // signal intrusions render on their own channel: SIG prefix, own accent
    const sig = msg.channel === 'sig'
    line.className = `feed-line tone-${msg.tone}${sig ? ' sig' : ''}`
    const id = String(++this.seq % 1000).padStart(3, '0')
    line.innerHTML = `<span class="feed-tag">${sig ? 'SIG' : 'NET'}·${id}</span> <span class="feed-text"></span>`
    const textEl = line.querySelector('.feed-text') as HTMLElement
    this.root.appendChild(line)
    while (this.root.children.length > 3) this.root.firstChild?.remove()

    // typewriter reveal, then linger, then fade
    const text = msg.text
    let i = 0
    const reveal = window.setInterval(() => {
      i += 2
      textEl.textContent = text.slice(0, i)
      if (i >= text.length) {
        window.clearInterval(reveal)
        window.setTimeout(() => {
          line.classList.add('fade')
          window.setTimeout(() => line.remove(), 900)
        }, this.lingerMs)
      }
    }, 14)
  }

  clear(): void {
    this.root.innerHTML = ''
  }
}
